// redux
import { useStore } from "react-redux";
import { success, error as toastError } from "hyc-store/reducers/toast";

// components
import { Button } from "shared/components/bulma/button";

import * as helper from "./helper";

const ChargeButton = ({ item, hidden, onChange }) => {
    const store = useStore();

    const handleCharge = async () => {
        if (!window.confirm(`Are you sure you want to create a single item subscription on Stripe for this customer (${item.barcode})?`)) {
            return;
        }
        try {
            await helper.chargeSingleItem(item);
            onChange && onChange();
            store.dispatch(success('Success! The customer has been charged on Stripe!'));
        } catch (error) {
            store.dispatch(toastError(error.message));
        };
    };

    if (item.status !== 'missing') {
        return null;
    };

    const buttonClasses = [
        'button is-link is-outlined',
        hidden ? 'is-hidden' : ''
    ].join(' ');

    return (
        <Button name="charge" className={buttonClasses}
            onClick={handleCharge}>
            Charge customer
        </Button>
    )
}

export { ChargeButton };
